import axios, { AxiosError } from "axios"
import { IInfoUserResponse } from "types"
import { INFO_PATH, MODULE_PATH, USER_PATH } from "../../constants/paths"
import {
  requestInterceptorErrorSecurityCredentials,
  requestInterceptorSuccessCredentials,
  responseInterceptorErrorCredentials,
  responseInterceptorSuccessCredentials,
} from "interceptors"

const instance = axios.create({
  baseURL: process.env.REACT_APP_CREDENTIALS_API_SERVICE_DOMAIN,
})

instance.interceptors.request.use(
  requestInterceptorSuccessCredentials,
  requestInterceptorErrorSecurityCredentials
)

instance.interceptors.response.use(
  responseInterceptorSuccessCredentials,
  responseInterceptorErrorCredentials
)

export const getUserInfoByTokenService = async (token: string) => {
  try {
    const result = await instance.get(USER_PATH + MODULE_PATH + INFO_PATH, {
      params: {
        token,
      },
    })
    return result.data as IInfoUserResponse
  } catch (error: any) {
    throw new Error((error as AxiosError)?.response?.data)
  }
}
